import { useNavigate, useParams } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";

import {
  Button,
  IconButton,
  Input,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
  TextField,
} from "@mui/material";
import { useState } from "react";

import MainContainer from "../../../layout/MainContainer";

const AddEmployee = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [visaImage, setVisaImage] = useState("");

  const [citizenship, setCitizenship] = useState("default");
  const [residence, setResidence] = useState("default");
  const [designation, setDesignation] = useState("default");
  const [teamLeader, setTeamLeader] = useState("default");
  const [isLeader, setIsLeader] = useState("default");
  const [visaStatus, setVisaStatus] = useState("default");
  const [documents, setDocuments] = useState<{ [key: string]: string }>({
    passport: "",
    emiratesId: "",
    cv: "",
    offerLetter: "",
    employementContract: "",
    inventoryAcknowledgementFrom: "",
    resignationLetter: "",
    visaCancellation: "",
    additionalDocuments: "",
  });

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const handleCitizenship = (event: SelectChangeEvent) => {
    setCitizenship(event.target.value as string);
  };
  const handleResidence = (event: SelectChangeEvent) => {
    setResidence(event.target.value as string);
  };
  const handleDesignation = (event: SelectChangeEvent) => {
    setDesignation(event.target.value as string);
  };

  const handleTeamLeader = (event: SelectChangeEvent) => {
    setTeamLeader(event.target.value as string);
  };
  const handleIsLeader = (event: SelectChangeEvent) => {
    setIsLeader(event.target.value as string);
  };
  const handleVisaStatus = (event: SelectChangeEvent) => {
    setVisaStatus(event.target.value as string);
  };

  const handleFileUpload = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setDocuments((prev) => ({ ...prev, [key]: "" }));
      return;
    }

    // Only allow PDF files
    if (file.type !== "application/pdf") {
      alert("Only PDF files are allowed.");
      return;
    }

    const fileUrl = URL.createObjectURL(file);
    setDocuments((prev) => ({ ...prev, [key]: fileUrl }));
  };

  const handleBlogUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setVisaImage("");
      return;
    }

    // Generate a temporary URL for preview
    const imageUrl = URL.createObjectURL(file);
    setVisaImage(imageUrl);
  };

  return (
    <MainContainer>
      <div className="main_title fdx">
        <div>
          <h1>{id ? "Edit" : "Add"} Employee</h1>
          {/* <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
            <span onClick={() => navigate("/visa-type")}>
              
            </span>{" "}
            - {id ? "Edit" : "Add"} Visa Type
          </p> */}
        </div>
        <div className="right_s align_right">
          <Button className="btn btn_blue" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>
      </div>

      <div className="cards">
        <form className="form" action="">
          <div className="gap_p">
            <div className="control_group w_100">
              <label> Image</label>
              <div className="upload_box">
                <label>
                  {visaImage && (
                    <IconButton
                      className="crossIcon"
                      onClick={() => setVisaImage("")}
                    >
                      <CloseIcon />
                    </IconButton>
                  )}
                  <figure>
                    <img
                      src={visaImage ? visaImage : "/static/images/picture.png"}
                      alt="Upload"
                    />
                  </figure>
                  <IconButton className="uploadIcon">
                    <label htmlFor="icon-button-file">
                      <Button component="span" className="upload_image_btn">
                        <img src="/static/images/edit2_icon.svg" alt="Upload" />
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={(e: any) => {
                            handleBlogUpload(e);
                            e.target.value = null;
                          }}
                        />
                      </Button>
                    </label>
                  </IconButton>
                </label>
              </div>
            </div>

            <div className="control_group w_50">
              <label>Employee Name</label>
              <TextField
                variant="outlined"
                placeholder="Employee Name"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Company Email</label>
              <TextField
                variant="outlined"
                placeholder="Company Email"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Password</label>
              <TextField
                variant="outlined"
                placeholder="Password"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Personal Email</label>
              <TextField
                variant="outlined"
                placeholder="Personal Email"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Company Mobile Number</label>
              <TextField
                variant="outlined"
                placeholder="Company Mobile Number"
                fullWidth
                hiddenLabel
              />
            </div>

            <div className="control_group w_50">
              <label>Choose Citizenship</label>
              <Select
                fullWidth
                labelId="citizenship"
                id="citizenship"
                value={citizenship}
                onChange={handleCitizenship}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Afganistan</MenuItem>
                <MenuItem value={20}>Albania</MenuItem>
                <MenuItem value={20}>Algerria</MenuItem>
                <MenuItem value={20}>Andora</MenuItem>
              </Select>
            </div>

            <div className="control_group w_50">
              <label>Country of Residence</label>
              <Select
                fullWidth
                labelId="residence"
                id="residence"
                value={residence}
                onChange={handleResidence}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Afganistan</MenuItem>
                <MenuItem value={20}>Albania</MenuItem>
                <MenuItem value={20}>Algerria</MenuItem>
                <MenuItem value={20}>Andora</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Designation</label>
              <Select
                fullWidth
                labelId="designation"
                id="designation"
                value={designation}
                onChange={handleDesignation}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Accountant</MenuItem>
                <MenuItem value={20}>CEO</MenuItem>
                <MenuItem value={20}>Director</MenuItem>
                <MenuItem value={20}>Receptionist</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Date of Joining</label>
              <TextField
                type="date"
                variant="outlined"
                placeholder="Date of Joining"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Designation</label>
              <Select
                fullWidth
                labelId="teamLeader"
                id="teamLeader"
                value={teamLeader}
                onChange={handleTeamLeader}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Abdul Hussain</MenuItem>
                <MenuItem value={20}>John Doe</MenuItem>
                <MenuItem value={20}>Emma Smith</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Is Team Leader</label>
              <Select
                fullWidth
                labelId="isLeader"
                id="isLeader"
                value={isLeader}
                onChange={handleIsLeader}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Yes</MenuItem>
                <MenuItem value={20}>No</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Personal Mobile Number</label>
              <TextField
                variant="outlined"
                placeholder="Personal Mobile Number"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Dubai Contact Number</label>
              <TextField
                variant="outlined"
                placeholder="Dubai Contact Number"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Home Mobile Number</label>
              <TextField
                variant="outlined"
                placeholder="Home Mobile Number"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Emergency Contact Number</label>
              <TextField
                variant="outlined"
                placeholder="Emergency Contact Number"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Home Address</label>
              <TextField
                variant="outlined"
                placeholder="Home Address"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Current Address</label>
              <TextField
                variant="outlined"
                placeholder="Current Address"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Secondary Address</label>
              <TextField
                variant="outlined"
                placeholder="Secondary Address"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Passport Number</label>
              <TextField
                variant="outlined"
                placeholder="Passport Number"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Passport Expiry</label>
              <TextField
                type="date"
                variant="outlined"
                placeholder="Passport Expiry"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Have Passport</label>
              <Switch {...label} defaultChecked />
            </div>
            <div className="control_group w_50">
              <label>Visa Expiry</label>
              <TextField
                type="date"
                variant="outlined"
                placeholder="Visa Expiry"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Visa Status</label>
              <Select
                fullWidth
                labelId="visaStatus"
                id="visaStatus"
                value={visaStatus}
                onChange={handleVisaStatus}
              >
                <MenuItem disabled value="default">
                  Select
                </MenuItem>
                <MenuItem value={10}>Employement</MenuItem>
                <MenuItem value={20}>Freelance</MenuItem>
                <MenuItem value={20}>Spouse</MenuItem>
                <MenuItem value={20}>Visit</MenuItem>
              </Select>
            </div>
            <div className="control_group w_50">
              <label>Bank Name</label>
              <TextField
                variant="outlined"
                placeholder="Bank Name"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>Account Title</label>
              <TextField
                variant="outlined"
                placeholder="Account Title"
                fullWidth
                hiddenLabel
              />
            </div>
            <div className="control_group w_50">
              <label>IBAN Number</label>
              <TextField
                variant="outlined"
                placeholder="IBAN Number"
                fullWidth
                hiddenLabel
              />
            </div>

            {[
              { key: "passport", label: "Employee Passport" },
              { key: "emiratesId", label: "Employee Emirates Id" },
              { key: "cv", label: "Employee CV" },
              { key: "offerLetter", label: "Offer Letter" },
              { key: "employementContract", label: "Employement Contract" },
              {
                key: "inventoryAcknowledgementFrom",
                label: "Inventory Acknowledgement From",
              },
              {
                key: "resignationLetter",
                label: "Termination/Resignation Letter",
              },
              {
                key: "visaCancellation",
                label: "Visa Cancellation",
              },
              {
                key: "additionalDocuments",
                label: "Additional Documents",
              },
            ].map(({ key, label }) => (
              <div className="control_group w_50" key={key}>
                <label>{label} (PDF)</label>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <TextField
                    variant="outlined"
                    fullWidth
                    placeholder="No file chosen"
                    value={
                      documents[key] ? documents[key].split("/").pop() : ""
                    }
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment className="eye_btn" position="end">
                          <label htmlFor={key}>
                            <Button
                              component="span"
                              className="upload_image_btn"
                            >
                              <img
                                src="/static/images/upload_icon.svg"
                                alt="Upload"
                              />
                            </Button>
                          </label>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <Input
                    sx={{ display: "none" }}
                    id={key}
                    type="file"
                    inputProps={{ accept: "application/pdf" }}
                    onChange={(e: any) => {
                      handleFileUpload(e, key);
                      e.target.value = null;
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

          <div className="form_end_btn">
            <Button
              className="btn btn_secondary"
              //   onClick={() => navigate("/visa-type")}
            >
              Submit
            </Button>
          </div>
        </form>
      </div>
    </MainContainer>
  );
};

export default AddEmployee;
